<header>
    <img src="images/ecl-logo-central.png" alt="ECL League">
    <span class="home-message-1 mt-30">{{homeInfo().message1}}</span>
    <span>{{homeInfo().message2}}</span>
</header>

<div class="infos_current_season">
<!--    <div class="card left">{{homeInfo().resume}}</div>-->
<!--    <div class="card right">-->
<!--        <div>-->
<!--            <div class="row1">-->
<!--                <span class="prize-amount"><span class="primary">£</span>{{homeInfo().currentSeasonStats?.prize_pool_amount | number:'1.0-0'}}+ </span>-->
<!--                <span class="prize-pool secondary">Prize<br>Pool</span>-->
<!--            </div>-->
<!--            <div class="row2">{{homeInfo().currentSeasonStats?.nb_teams | number:'1.0-0'}} <span class="primary">Teams <span class="round-brackets">(</span></span>{{homeInfo().currentSeasonStats?.nb_divisions | number:'1.0-0'}} Divs<span class="round-brackets secondary">)</span></div>-->
<!--            <div class="row3">£<span class="primary">{{homeInfo().currentSeasonStats?.min_entry}}-{{homeInfo().currentSeasonStats?.max_entry}}</span> Entry</div>-->
<!--            <div class="row4"><span class="primary">Group stage:</span> {{homeInfo().currentSeasonStats?.group_stage_start | date: 'dd/MM'}}-{{homeInfo().currentSeasonStats?.group_stage_end | date: 'dd/MM'}}</div>-->
<!--            <div class="row5"><span class="primary">Playoffs:</span> {{homeInfo().currentSeasonStats?.playoffs_start | date: 'dd/MM'}}-{{homeInfo().currentSeasonStats?.playoffs_end | date: 'dd/MM'}}</div>-->
<!--        </div>-->
<!--    </div>-->

  <!--
    <div class="card left">
      <div class="image-container">
        <img src="images/ecl-logo-off.png" alt="ECL League">
      </div>
      {{homeInfo().resume}}
    </div>

    <div class="card right">
      <div class="image-container">
        <img src="images/ecl-logo-right.png" alt="ECL League">
      </div>
        <div>
            <div class="row1">
                <span class="prize-amount"><span class="primary">£</span>{{homeInfo().currentSeasonStats?.prize_pool_amount | number:'1.0-0'}}+ </span>
                <span class="prize-pool secondary">Prize<br>Pool</span>
            </div>
            <div class="row2">{{homeInfo().currentSeasonStats?.nb_teams | number:'1.0-0'}} <span class="primary">Teams <span class="round-brackets">(</span></span>{{homeInfo().currentSeasonStats?.nb_divisions | number:'1.0-0'}} Divs<span class="round-brackets secondary">)</span></div>
            <div class="row3">£<span class="primary">{{homeInfo().currentSeasonStats?.min_entry}}-{{homeInfo().currentSeasonStats?.max_entry}}</span> Entry</div>
            <div class="row4"><span class="primary">Group stage:</span> {{homeInfo().currentSeasonStats?.group_stage_start | date: 'dd/MM'}}-{{homeInfo().currentSeasonStats?.group_stage_end | date: 'dd/MM'}}</div>
            <div class="row5"><span class="primary">Playoffs:</span> {{homeInfo().currentSeasonStats?.playoffs_start | date: 'dd/MM'}}-{{homeInfo().currentSeasonStats?.playoffs_end | date: 'dd/MM'}}</div>
        </div>
    </div>
    -->

  <div id="media-player">
    <video controls playsinline loop preload="auto">
      <source [src]="getVideoLink()" type="video/mp4">
      {{ 'home.video_not_supported' | translate }}
    </video>
  </div>
</div>

<section class="stats">
    <h2>{{ 'home.stats' | translate }}</h2>
    <div class="row mt-20">
        <div class="stat">
            <img src="images/ecl-gamers.png" alt="">
            <div class="values">
                <span class="nb">{{homeInfo().globalStats?.nb_gamers | number:'1.0-0'}}+</span>
                <span class="label">{{ 'home.gamers' | translate }}</span>
            </div>
        </div>
        <div class="stat">
            <img src="images/ecl-teams.png" alt="Number of gamers">
            <div class="values">
                <span class="nb">{{homeInfo().globalStats?.nb_teams | number:'1.0-0'}}+</span>
                <span class="label">{{ 'home.teams' | translate }}</span>
            </div>
        </div>
        <div class="stat">
            <img src="images/ecl-divisions.png" alt="Number of divisions">
            <div class="values">
                <span class="nb">{{homeInfo().globalStats?.nb_divisions | number:'1.0-0'}}</span>
                <span class="label">{{ 'home.divisions' | translate }}</span>
            </div>
        </div>
        <div class="stat">
            <img src="images/ecl-cashprize.png" alt="Cashprize">
            <div class="values">
                <span class="nb">£{{homeInfo().globalStats?.cashprize_amount | number:'1.0-0'}}+</span>
                <span class="label">{{ 'home.cashprize' | translate }}</span>
            </div>
        </div>
    </div>
</section>

<hr>

<section class="teams">
    <h2>{{ 'home.teams' | translate }}</h2>
    <div class="row mt-20">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="homeInfo().slideConfig">
        @for (slide of homeInfo().slides; track slide.id) {
            <div ngxSlickItem class="slide">
                  <img src="{{ slide.image }}" alt="{{ slide.caption }}">
                  <!-- <img src="{{ slide.image }}" alt="{{ slide.caption }}" nbTooltip="{{ slide.caption }}" nbTooltipPlacement="top" nbTooltipStatus="control">-->
            </div>
        }
    </ngx-slick-carousel>
    </div>
</section>

<hr>

<app-contact></app-contact>
